export const APP_FILE_LEGAL_LIST= "/legal-plus";
export const APP_FILE_LEGAL_PLUS= "/legal-plus/manage";